@use '../../sass/theme';

$variants: primary, secondary, success, info, warning, danger, low, high, mid;

@mixin get-variants() {
  @each $variant in $variants {
    &--#{$variant} {
      color: var(--jui-#{$variant}-color--contrast);
      background-color: var(--jui-#{$variant}-color);
      border-color: var(--jui-#{$variant}-color);

      &.chip--selectable {
        background-color: var(--jui-input-color-bg);
        border: 1px solid var(--jui-input-color-border);
        color: var(--jui-input-color);
      }


      &:active.chip--selectable {
        background-color: var(--jui-#{$variant}-color--darker);
        border-color: var(--jui-#{$variant}-color--darker);
        color: var(--jui-#{$variant}-color--contrast);
      }

      &.chip--selected {
        color: var(--jui-#{$variant}-color--contrast);
        background-color: var(--jui-#{$variant}-color);
        border-color: var(--jui-#{$variant}-color);
      }
    }
  }
}


:host {
  display: inline-block;

  .chip {
    display: flex;
    align-items: center;
    justify-content: space-between;
    column-gap: var(--jds-space-xs);
    font-family:  var(--jui-font-family), sans-serif;
    font-size: var(--jui-input-fs-sm);
    color: var(--jui-input-color);
    border: 1px solid var(--jui-input-color-border);
    border-radius: var(--default-chip-border-radius);
    padding:  var(--jds-space-inset-squish-xs);
    background-color: var(--jui-input-color-bg);

    &:active.chip--selectable {
      background-color: var(--jui-primary-color--darker);
      border-color: var(--jui-primary-color--darker);
      color: var(--jui-primary-color--contrast);
    }

    &__icon {
      height: 16px;

      &--appear {
        animation: appear 150ms ease-out forwards;
      }
    }

    &--selectable {
      cursor: pointer;
    }

    &--selected {
      background-color: var(--jui-primary-color);
      border-color:var(--jui-primary-color);
      color: var(--jui-primary-color--contrast);
    }

    @include get-variants;

    &--removing {
      animation: remove 150ms ease-out forwards;
    }

    &--disabled {
      pointer-events: none;
      cursor: not-allowed;
      touch-action: none;
      border-color:var(--jui-input-color-disabled-bg) !important;
      background-color: var(--jui-input-color-disabled-bg) !important;
      color: var(--jui-input-color-disabled) !important;
    }

    // size modifiers
    &--sm {
      padding:  var(--jds-space-inset-squish-xxs);
      font-size: 12px;
      line-height: 12px;
      & .chip__icon {
        position: relative;
        font-size: 12px;
        height: 12px;
        line-height: 12px;
        top: -1px;
      }
    }

    &--lg {
      padding:  var(--jds-space-inset-squish-sm);
      font-size: var(--jui-input-fs);
      column-gap: var(--jds-space-sm);
    }

    &--pill {
      border-radius: var(--default-chip-border-radius--pill);
    }
  }
}


@keyframes appear {
  0% {
    transform-origin: center;
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}

@keyframes remove {
  0% {
    transform-origin: center;
    transform: scale(1);
    opacity: 1;
  }

  60% {
    transform: scale(.8, .2);
  }

  100% {
    transform: scale(0);
    opacity: 0;
  }
}

